import { ReduxStateType } from '../../../redux/types';

export const getReduxFiltersSelector = (state: ReduxStateType) => {
	return state.filters;
};
